import React from 'react';
import { faqs } from '../mock/mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Input } from '../components/ui/input';
import { Search } from 'lucide-react';

const FAQPage = () => {
  const [searchTerm, setSearchTerm] = React.useState('');

  const filteredFaqs = faqs.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const categories = [
    {
      name: 'Generelt',
      faqs: filteredFaqs
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Ofte stilte spørsmål
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Finn svar på de mest stilte spørsmålene om DigiCar
          </p>

          {/* Search */}
          <div className="relative max-w-2xl mx-auto">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <Input
              type="text"
              placeholder="Søk etter spørsmål..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-12 py-6 text-lg"
            />
          </div>
        </div>

        {/* FAQ Categories */}
        {categories.map((category) => (
          <div key={category.name} className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{category.name}</h2>
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <Accordion type="single" collapsible className="space-y-4">
                {category.faqs.map((faq, index) => (
                  <AccordionItem 
                    key={faq.id} 
                    value={`item-${faq.id}`} 
                    className="border-b border-gray-200 last:border-0"
                  >
                    <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-yellow-600 transition-colors">
                      {faq.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-gray-600 pt-2">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
              
              {category.faqs.length === 0 && (
                <p className="text-center text-gray-500 py-8">
                  Ingen spørsmål funnet. Prøv et annet søkeord.
                </p>
              )}
            </div>
          </div>
        ))}

        {/* Contact Section */}
        <div className="bg-yellow-500 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold text-black mb-4">
            Fant du ikke svar på spørsmålet ditt?
          </h3>
          <p className="text-gray-900 mb-6">
            Ta kontakt med kundeservice så hjelper vi deg gjerne!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:47494900" 
              className="inline-block bg-black hover:bg-gray-800 text-white font-semibold px-8 py-4 rounded-lg transition-colors"
            >
              Ring oss: 47 49 49 00
            </a>
            <a 
              href="mailto:post@digicar.no" 
              className="inline-block bg-white hover:bg-gray-100 text-black font-semibold px-8 py-4 rounded-lg transition-colors"
            >
              Send e-post
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;